<template>
  <hic-dialog v-loading="loading" append-to-body :close-on-click-modal="false" title="导出新开医嘱单" :visible="visible" width="30rem" top="30vh" @close="close()">
    <el-radio-group v-model="condition.ifNotExport" style="margin-top:20px;margin-bottom:10px">
      <el-radio :label="false">全部医嘱</el-radio>
      <el-radio :label="true">未导出医嘱</el-radio>
    </el-radio-group>

    <div slot="footer">
      <el-button type="primary" size="large" @click="exportExcel">导 出</el-button>
      <el-button type="info" size="large" @click="close()">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from "./api";
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      condition: {
        ifNotExport: false,
      },
      advice: {
        count: 1,
      },
    };
  },
  methods: {
    exportExcel() {
      this.loading = true;
      api.ExportExcel.getAdviceCount(this.condition).then((res) => {
        this.advice = res;
        if (this.advice.count) {
          api.ExportExcel.downloadAdvice(this.condition).then((res) => {
            this.$message.success("导出新开医嘱单成功！");
          }).finally(() => {
            this.loading = false;
          });
        }
      }).finally(() => {
        if (!this.advice.count) {
          this.loading = false;
          this.$message.error(this.condition.ifNotExport ? "没有新开未导出医嘱，无法导出！" : "没有新开医嘱，无法导出！");
        }
      });
    },
    close() {
      this.$emit('update:visible', false);
    }
  }
}
</script>